import { render, staticRenderFns } from "./SundryItemsHome.vue?vue&type=template&id=163cb382&"
import script from "./SundryItemsHome.vue?vue&type=script&lang=js&"
export * from "./SundryItemsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports